export default __webpack_public_path__ + "static/media/keyFeature_1.1f5b37fb.svg";